import React from "react";
import { Say } from "../../languages";

interface BackupCtaProps {
  url: string;
}

const BackupCta: React.FC<BackupCtaProps> = (props) => {
  return (
    <div className="error-wrapper__cta">
      <a className="btn btn-primary" href={props.url}>
        <Say phrase="errors.backup_cta" />
      </a>
    </div>
  );
};

export default BackupCta;
